import { useAppConstantsContext } from '@ltvco/refresh-lib/ctx';
import { Person } from '@mui/icons-material';

import { type JudgeResult } from '../../types';
import {
  CardContainer,
  ContentContainer,
  HeaderRow,
  CardIconContainer,
  CardTitle,
  DetailsContainer,
  DetailRow,
  DetailLabel,
  DetailValue,
  ViewButton,
  formatDate,
  getLimitedList,
} from '../shared';

export interface JudgeSearchResultCardProps {
  judgeItem: JudgeResult;
  isHovered?: boolean;
}

export const JudgeSearchResultCard = ({
  judgeItem,
  isHovered,
}: JudgeSearchResultCardProps) => {
  const { links } = useAppConstantsContext();
  const { name, positions, dod, school } = judgeItem;

  // Get current position (most recent)
  const currentPosition = positions?.[0];

  // Format dates
  const appointmentDate = currentPosition?.date_start
    ? formatDate(currentPosition.date_start)
    : '';
  const deathDate = dod ? formatDate(dod) : '';

  // Get limited schools list
  const schoolsList = getLimitedList(school, 3);

  const handleViewClick = () => {
    window.open(
      `${links.baseUrl}/dashboard/court-cases/people/${judgeItem.id}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return (
    <CardContainer isHovered={isHovered} hoverColor="grey100">
      <ContentContainer>
        <HeaderRow>
          <CardIconContainer size={24}>
            <Person />
          </CardIconContainer>
          <CardTitle>{name}</CardTitle>
        </HeaderRow>

        <DetailsContainer>
          {currentPosition && (
            <DetailRow>
              <DetailLabel minWidth="110px" mobileMinWidth="70px">
                Court:
              </DetailLabel>
              <DetailValue>{currentPosition.court_full_name}</DetailValue>
            </DetailRow>
          )}

          {appointmentDate && (
            <DetailRow>
              <DetailLabel minWidth="110px" mobileMinWidth="70px">
                Appointed:
              </DetailLabel>
              <DetailValue>{appointmentDate}</DetailValue>
            </DetailRow>
          )}

          {schoolsList && (
            <DetailRow>
              <DetailLabel minWidth="110px" mobileMinWidth="70px">
                School:
              </DetailLabel>
              <DetailValue>
                {schoolsList.text}
                {schoolsList.remaining > 0 &&
                  ` (+${schoolsList.remaining} more)`}
              </DetailValue>
            </DetailRow>
          )}

          {deathDate && (
            <DetailRow>
              <DetailLabel minWidth="110px" mobileMinWidth="70px">
                Deceased:
              </DetailLabel>
              <DetailValue>{deathDate}</DetailValue>
            </DetailRow>
          )}

          {currentPosition?.selection_method && (
            <DetailRow>
              <DetailLabel minWidth="110px" mobileMinWidth="70px">
                Selection:
              </DetailLabel>
              <DetailValue>{currentPosition.selection_method}</DetailValue>
            </DetailRow>
          )}
        </DetailsContainer>
      </ContentContainer>

      <ViewButton variant="outlined" onClick={handleViewClick}>
        View
      </ViewButton>
    </CardContainer>
  );
};
